import { search } from "../../BaseRepositoryComponents";

export async function findCompaniesV3(
  filters = {
    ativo: "strict:S",
  }
) {
  const searchParams = new URLSearchParams(window.location.search);

  const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/usuario/current/empresa`;
  const url = new URL(path);

  const headers = new Headers();
  const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
  headers.append("Authorization", token);
  headers.append("content-type", "application/json");

  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );
  return search(decodeURIComponent(url), "GET", headers);
}
